module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "P_WFP_ChapHead",
    attrs: {
      "id": "auto_bookmark_table_of_contents_1"
    }
  }, [_c('span', [_vm._v("Book Description")])]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_BodyTextFirstPara"
  }, [_vm._v("In "), _c('i', [_vm._v("The Jesus Incident")]), _vm._v(" Herbert and Ransom introduced Ship, an artificial intelligence that believed it was God, abandoning its unworthy human cargo on the all-sea world of Pandora. Now centuries have passed. The descendants of humanity, split into Mermen and Islanders, must reunite … because Pandora’s original owner is returning to life!")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e9677be","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0001.vue
// module id = 60
// module chunks = 0